// extracted by mini-css-extract-plugin
export var fadeInOut = "_13-3";
export var icon = "_13-4";
export var savedIndicator = "_13-2";
export var savingIndicator = "_13-0";
export var spin = "_13-1";